import { actionTypes } from './actions'

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.TENANTS_RECEIVED:
      return action.payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/with-tenants/container/reducer.js